import { useContext } from "react";
import { AppStoreContext } from "./context/context";
import { useStore } from "zustand";
import { AppState } from "./states";

export const useAppStore = <T>(selector: (state: AppState) => T): T => {
  const store = useContext(AppStoreContext);
  if (!store) {
    throw new Error(
      "Missing AppStoreContext.Provider in the tree. AppState could not be initialized.",
    );
  }
  return useStore(store, selector);
};
